<div *ngIf="loanAppPageSvc.selectedLoanApplication$ | async as loanApp">



    <div class="row main-row">
        <div class="col-12 col-lg-5 main-column">
            <lgv-status-tracker></lgv-status-tracker>
            <!-- <div class="alert lgv-border">

                <div class="section-header primary-color">Loan Timeline</div>

                <ng-container *ngIf="timeline$ | async as timeline">
                    <div *ngFor="let x of timeline.loanStatuses">
                        <div class="timeline-status tooltipcell" (click)="showToolTipModal(x)">
                            <div class="tooltiptext" [innerHTML]="getToolTipForStatus(x)"></div>
                            <div class="button-looking-div "
                                [ngClass]="x.isComplete || isActive(x) ? 'complete' : 'default'">
                                <fa-icon icon="check" *ngIf="x.isComplete"></fa-icon>
                            </div>
                            <div class="status-text" [ngClass]="{'strong': isActive(x)}">{{x.name}}</div>
                            <div class="status-date" *ngIf="x.isComplete">{{x.date | date:'MM/dd/yy'}}</div>
                            <div style="clear:both"></div>
                        </div>
                        <div *ngIf="!isLastItem(x)" class="connector"></div>
                    </div>
                </ng-container>
            </div> -->
        </div>

        <div class="col-12 col-lg-7  main-column">
            <div class="alert lgv-border">

                <div class="row" *ngIf="loanApp.loanInfo as loanInfo">
                    <ng-container *ngIf="isInternalUser">
                        <div class="col-12 section-header with-underline primary-color">Key Dates</div>
                        <div class="col-12">
                            <hr class="section-header-underline" />
                        </div>
                        <div class="col-4 col-lg-4" *ngIf="loanApp?.loanTimeline?.keyDates?.lockExpiration">
                            <div class="label">Lock Exp Date <fa-icon icon="lock"></fa-icon></div>
                            <div class="value">{{loanApp?.loanTimeline?.keyDates?.lockExpiration | date:'MM/dd/yy'}}</div>
                        </div>
                        <div class="col-6 col-lg-4" *ngIf="loanApp?.loanTimeline?.keyDates?.estimatedClosing">
                            <div class="label">Estimated Closing Date</div>
                            <div class="value">{{loanApp?.loanTimeline?.keyDates?.estimatedClosing | date:'MM/dd/yy'}}</div>
                        </div>
                        <div class="col-6 col-lg-4" *ngIf="loanApp?.loanTimeline?.keyDates?.firstPaymentDate">
                            <div class="label">First Payment Date</div>
                            <div class="value">{{loanApp?.loanTimeline?.keyDates?.firstPaymentDate | date:'MM/dd/yy'}}</div>
                        </div>
                    </ng-container>

                    <div class="col-12 section-header with-underline primary-color">
                        Loan Information <span style="color: #404040; font-weight: 500;" *ngIf="loanApp?.loanTimeline?.keyDates?.rateLockedDate">Locked on {{loanApp?.loanTimeline?.keyDates?.rateLockedDate | date:'MM/dd/yy'}} <fa-icon icon="lock"></fa-icon></span>
                    </div>

                    <div class="col-12">
                        <hr class="section-header-underline" />
                    </div>

                    <div class="col-6 col-lg-4" *ngIf="loanInfo?.purpose?.name">
                        <div class="label">Loan Purpose</div>
                        <div class="value">{{loanInfo?.purpose?.name}}</div>
                    </div>
                    <div class="col-6 col-lg-4" *ngIf="loanInfo?.occupancy?.name">
                        <div class="label">Occupancy</div>
                        <div class="value">{{loanInfo?.occupancy?.name}}</div>
                    </div>
                    <div class="col-6 col-lg-4" *ngIf="loanInfo?.loanAmount">
                        <div class="label">Loan Amount</div>
                        <div class="value">${{loanInfo?.loanAmount | number : '1.0-0'}}</div>
                    </div>
                    <div class="col-6 col-lg-4" *ngIf="loanInfo?.appraisalValue && loanInfo?.loanAmount">
                        <div class="label">Down Payment</div>
                        <div class="value">${{loanInfo?.appraisalValue - loanInfo?.loanAmount | number : '1.0-0'}}
                        </div>
                    </div>
                    <div class="col-6 col-lg-4" *ngIf="loanInfo?.purchasePrice">
                        <div class="label">Purchase Price</div>
                        <div class="value">${{loanInfo?.purchasePrice | number : '1.0-0'}}</div>
                    </div>
                    <div class="col-6 col-lg-4" *ngIf="loanInfo?.proposedHousingExpense?.firstMortgagePrincipalAndInterest">
                        <div class="label">Principal & Interest</div>
                        <div class="value">{{loanInfo?.proposedHousingExpense?.firstMortgagePrincipalAndInterest | number : '1.0-0'}}</div>
                    </div>
                    <ng-container *ngIf="isClient">
                        <div class="col-6 col-lg-4" *ngIf="loanApp?.loanTimeline?.keyDates?.estimatedClosing">
                            <div class="label">Estimated Closing Date</div>
                            <div class="value">{{loanApp?.loanTimeline?.keyDates?.estimatedClosing | date:'MM/dd/yy'}}</div>
                        </div>
                        <div class="col-6 col-lg-4" *ngIf="loanApp?.loanTimeline?.keyDates?.firstPaymentDate">
                            <div class="label">First Payment Date</div>
                            <div class="value">{{loanApp?.loanTimeline?.keyDates?.firstPaymentDate | date:'MM/dd/yy'}}</div>
                        </div>
                    </ng-container>
                    <div class="col-6 col-lg-4" *ngIf="loanInfo?.noteRate">
                        <div class="label">Rate</div>
                        <div class="value">{{loanInfo?.noteRate | number : '1.3-3'}}%</div>
                    </div>
                    <div class="col-6 col-lg-4" *ngIf="loanInfo?.mortgageInsurance">
                        <div class="label">Mortgage Insurance</div>
                        <div class="value">$ {{loanInfo?.mortgageInsurance | number : '1.0-0'}}</div>
                    </div>
                    <div class="col-6 col-lg-4" *ngIf="loanInfo?.confirmedLockPeriod != null">
                        <div class="label">Lock Period</div>
                        <div class="value">{{loanInfo?.confirmedLockPeriod}}</div>
                    </div>

                    <div class="col-12 section-header with-underline primary-color">Actions</div>
                    <div class="col-12">
                        <hr class="section-header-underline" />
                    </div>

                    <div class="button-group">
                        <ng-container *ngIf="loanAppPageSvc.isPreApplicationMode && !loanInfo?.loanNumber">
                            <ng-container *ngIf="!isClient">
                                <button class="btn white flex-button" (click)="goToLoanAppPage()">
                                    Start Loan Application &nbsp;
                                    <span *ngIf="(lgvUserSvc.IsPreLicensedAgent$ | async)">
                                        <fa-icon style="color: #9B9B9B;" [icon]="['far', 'lock-keyhole']"></fa-icon>
                                    </span>
                                </button>
                            </ng-container>
                        </ng-container>
                    
                        <ng-container *ngIf="!loanAppPageSvc.isPreApplicationMode || !!loanInfo?.loanNumber">
                            <button class="btn white flex-button" (click)="goToLoanAppPage()">
                            <!-- Don't show pre-qual if app has been submitted -->
                            <!-- <button class="btn white" style="margin-right:20px;" (click)="goToShortAppPage()">Get Pre-Qualification</button> -->
                                {{ isLoanSubmitted() ? 'View Loan Application' : 'Edit Loan Application' }}
                            </button>
                        </ng-container>
                    
                        <ng-container>
                            <button class="btn white flex-button" (click)="!loanApp.isDeleted ? onConfirmArchiveLoan() : restoreLoan()">
                                {{ !loanApp.isDeleted ? 'Archive Loan Application' : 'Restore Loan Application' }}
                                <span *ngIf="(lgvUserSvc.IsPreLicensedAgent$ | async)">
                                    <fa-icon style="color: #9B9B9B;" [icon]="['far', 'lock-keyhole']"></fa-icon>
                                </span>
                            </button>
                        </ng-container>
                    </div>

                </div>

            </div>

        </div>

    </div>

</div>